function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFallbeschreibung = function SvgFallbeschreibung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H2a2.006 2.006 0 0 0-2 2v16a2.006 2.006 0 0 0 2 2h12a2.006 2.006 0 0 0 2-2V6Zm2 16H4v-2h8Zm0-4H4v-2h8ZM9 7V1.5L14.5 7Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgFallbeschreibung;